<template>
  <div>
    <div class="row-head">
      <span>
        <i class="el-icon-warning" />
        请录入成员及角色：市级课题前3主要参与者，4-6参与者；省级课题前6主要参与者，7-9参与者。
      </span>
      <div style="float:right;">
        <el-button type="primary" icon="el-icon-plus" circle @click="addGoods" v-if="!readonly"></el-button>
      </div>
    </div>
    <el-table ref="list" border :data="tableData" style="width: 100%">
      <el-table-column prop="Discount" label="成员名称">
        <template slot-scope="{ row, $index }">
          <el-input
            v-model="row.TeacherName"
            @focus="onTeacherDialog($index)"
            placeholder="点击选择"
            v-if="!readonly"
          ></el-input>
          <span v-else>{{row.TeacherName}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Discount" label="角色">
        <template slot-scope="{ row }">
          <el-select
            v-model="row.Role"
            v-if="!readonly"
            style="width:100%;"
            @change="onchange(row)"
          >
            <el-option value="主要参与者" label="主要参与者"></el-option>
            <el-option value="参与者" label="参与者"></el-option>
            <el-option value="参与" label="参与"></el-option>
          </el-select>
          <span v-else>{{row.Role}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="80px" v-if="!readonly">
        <template slot-scope="{ row,$index }">
          <!-- <el-link icon="el-icon-copy-document" style="margin-right:10px;" @click="copy(row,$index)" :underline="false">复制</el-link> -->
          <el-link icon="el-icon-delete" @click="del(row,$index)" :underline="false">删除</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-divider></el-divider>
    <teacher-dialog ref="teacherDialog" in-dialog selectable @select="setTeacher" />
  </div>
</template>
<script>
import teacherDialog from "@/components/fa/teacher/listDialog";
export default {
  props: {
    info: {},
    readonly: {
      type: Boolean,
      default: false,
    },
    showTax: {
      type: Number,
      default: 0,
    },
  },
  components: {
    teacherDialog,
  },
  data() {
    return {
      tableData: [],
      tableDel: [],
      // sApi: require("@/api/goods/goods").default,
      // api: require("@/api/sale/stInDoc").default,
      // saleApi: require("@/api/sale/sales").default,
      // account_api: require("@/api/goods/goods").default,
      PriAdjustGoodsList: [],
      tbindex: 0,
    };
  },

  methods: {
    onchange(row) {
      if (row.T !== 0) row.T = 1;
    },
    setTeacher(t) {
      if (this.tableData[this.tbindex].T !== 0) {
        this.tableData[this.tbindex].T = 1;
      }
      this.tableData[this.tbindex].TeacherId = t.TeacherId;
      this.tableData[this.tbindex].TeacherName = t.TeacherName;
    },
    onTeacherDialog(index) {
      this.tbindex = index;
      this.$refs.teacherDialog.open().then((that) => {
        that.getData({ IsAll: true });
      });
    },
    getDataFromOrder(id) {
      this.saleApi.getGoodsList(id).then((res) => {
        this.tableData.forEach((item) => {
          if (item.T !== 0) {
            this.tableDel.push({ ...item, T: 2 });
          }
        });
        res.Data.forEach((item) => {
          item.T = 0;
          item.OrderGoodsId = 0;
        });
        this.tableData = res.Data;
        console.log(this.tableData);
      });
    },
    getData() {
      console.log(this.info);
      this.info.Members.forEach((e) => {
        e.T = null;
      });
      this.tableData = this.info.Members;
      // this.saleApi.getGoodsList(this.info.OrderId).then((res) => {
      //   this.tableData = res.Data;
      // });
    },
    del(row, index) {
      console.log(index);
      this.$confirm("确认删除该行数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        if (row.T !== 0) {
          this.tableDel.push({ ...row, T: 2 });
        }
        this.tableData.splice(index, 1);
      });
    },
    copy(row, index) {
      this.tableData.splice(index, 0, { ...row });
      this.tableData[index].OrderGoodsId = 0;
      this.tableData[index].T = 0;
    },
    addGoods() {
      // let ids = this.PriAdjustGoodsList.map((x) => x.GoodsId);
      // this.$refs.goodsDialog.open().then((that) => {
      //   that.getData({ Status: 1, NotIds: ids });
      // });
      let goods = { T: 0, TeacherId: 0, TeacherName: "", Role: "" };
      this.tableData.push(goods);
    },
  },
};
</script>

<style>
.el-link {
  font-size: 14px;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
}
</style>